import { useState } from "react";

/**
 * Premium image with graceful fallback. On error, replaces broken-image icon with
 * a KUTZ-branded dark tile and gold K mark rather than a browser default.
 */
export default function ImgFallback({ src, alt = "", className = "", ...rest }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={`bg-ink border border-cream/10 flex items-center justify-center overflow-hidden ${className}`}
        role="img"
        aria-label={alt || "KUTZ"}
        data-testid="img-fallback"
        {...rest}
      >
        <div className="flex flex-col items-center gap-2 opacity-70">
          <svg width="36" height="36" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="6" width="8" height="52" fill="#C5A059" />
            <path d="M16 32 L46 6 L58 6 L28 34 L58 58 L46 58 L16 34 Z" fill="#C5A059" />
          </svg>
          <span className="text-[10px] uppercase tracking-[0.25em] text-cream/50">KUTZ</span>
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={className}
      {...rest}
    />
  );
}
